import type React from 'react'
import type { ReactNode } from 'react'

import { CardStyled } from './styles'

export interface CardProps {
  title?: ReactNode | string
  children?: ReactNode
  textColor?: 'neutral.high'
  titleColor?: 'secondary' | 'black'
  className?: string
}

export const Card: React.FC<CardProps> = ({
  title,
  children,
  textColor,
  titleColor = 'secondary',
  className,
}) => {
  return (
    <CardStyled
      className={className}
      data-testid="card"
      textColor={textColor}
      titleColor={titleColor}
    >
      {title && <h3 data-testid="card-title">{title}</h3>}
      <>{children}</>
    </CardStyled>
  )
}
